// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Rm-z","tupacHeader":"Sm-z","tupacHeader2":"Tm-z","tupacMenu":"Um-z","tupacMenu2":"Vm-z","tupacMain":"Wm-z","tupacMain2":"Xm-z"};